import { DangerColorful } from "@monta/icons";
import styles from "./styles.module.scss";
type Props = {
  rankWN: number;
  levelWN: number;
};
const NoWrongAnswers = (props: Props) => {
  const { levelWN, rankWN } = props;

  return (
    <div className={styles["no-wrong-answers"]}>
      <DangerColorful />
      <div className={styles["no-wrong-answers__text"]}>
        اگر پاسخ اشتباه نداشتید رتبه شما {rankWN} و تراز شما {levelWN} میشد.
      </div>
    </div>
  );
};

export default NoWrongAnswers;
